define({
  lp_dc: 'lo',
  lp_zone: 'z2',

  //domains
  __RegistrationConfigUrl: {
    qa: 'qtvr-wng052.dev.lprnd.net',
    default: '{{{dc}}}.register.liveperson.net'
  },
  __createAccountUrl: {
    qa: 'qtvr-wap13.dev.lprnd.net',
    default: '{{{dc}}}.acc-create.liveperson.net'
  },
  __AdsUrl: {
    qa: 'qtvr-wap01.dev.lprnd.net',
    default: '{{{zone}}}.ads.liveperson.net'
  },
  __loggos: {
    ci: 'lp-loggos-static-ci.dev.lprnd.net',
    'static-ci': 'lp-loggos-static-ci.dev.lprnd.net',
    qa: 'lp-loggos-qa.dev.lprnd.net',
    default: '{{{zone}}}.loggos.liveperson.net'
  },
  __adminArea: {
    ci: 'tlvciweb.dev.lprnd.net',
    'static-ci': 'prun-static-ci.dev.lprnd.net',
    qa: 'le2.dev.lprnd.net',
    'va-a': 'base.liveperson.net',
    'ca-a': 'ca-a.c.liveperson.net',
    'z0-intg': 'server.fr.liveperson.net',
    z1: 'server.iad.liveperson.net',
    z2: 'server.lon.liveperson.net',
    z3: 'server.sy.liveperson.net'
  },
  __intentDashboardDomain: {
    qa: 'https://intent-qa.dev.lprnd.net',
    default: 'https://{{{zone}}}.intent.liveperson.net'
  },
  __performanceOptimizerDomain: {
    qa: 'https://performance-portal-qa.dev.lprnd.net',
    default: 'https://{{{dc}}}.performance.liveperson.net',
  },
  __staffForecasterDomain: {
    qa: 'https://lp-staffforecaster-qa.dev.lprnd.net',
    default: 'https://{{{dc}}}.staff-forecaster.liveperson.net',
  },
  __dataTransporterDomain: {
    qa: 'https://lp-dataconnector-web-qa.dev.lprnd.net',
    default: 'https://{{{dc}}}.transporter.liveperson.net',
  },
  __connectionPanel: {
    ci: 'https://connection-panel.dev.lprnd.net',
    'static-ci': 'https://connection-panel.dev.lprnd.net',
    qa: 'https://connection-panel.dev.lprnd.net',
    'va-a': 'https://z1-a.connection-panel.liveperson.net',
    'ca-a': 'https://z1-a.connection-panel.liveperson.net',
    z1: 'https://z1.connection-panel.liveperson.net',
    z2: 'https://z2.connection-panel.liveperson.net',
    z3: 'https://z3.connection-panel.liveperson.net'
  },

  __visitorFeedV2: {
    qa: 'https://visitorfeedv2-qa.dev.lprnd.net',
    'va-a': 'https://z1-a.visitorfeedv2.liveperson.net',
    'ca-a': 'https://z1-a.visitorfeedv2.liveperson.net',
    'z1-a': 'https://z1-a.visitorfeedv2.liveperson.net',
    z1: 'https://z1.visitorfeedv2.liveperson.net',
    z2: 'https://z2.visitorfeedv2.liveperson.net',
    z3: 'https://z3.visitorfeedv2.liveperson.net'
  },

  __messagingGatewayDomain: {
    qa: 'lp-connector2sms-qa.dev.lprnd.net',
    ca: 'ca1.msg-gw.liveperson.net',
    default: '{{{dc}}}.msg-gw.liveperson.net'
  },

  __botCentralDomain: {
    dev: 'https://botplatform-dev.dev.lprnd.net',
    tlv: 'https://botplatform-dev.dev.lprnd.net',
    'va-a': 'https://va-a.botplatform.liveperson.net',
    'ca-a': 'https://ca-a.botplatform.liveperson.net',
    z1: 'https://va.botplatform.liveperson.net',
    z2: 'https://lo.botplatform.liveperson.net',
    z3: 'https://sy.botplatform.liveperson.net'
  },
  __mavenDomain: {
    qa: 'https://lp-mavenhub-qa.dev.lprnd.net',
    'ca-a': 'https://ca-a.maven.liveperson.net',
    'va-a': 'https://va-a.maven.liveperson.net',
    default: 'https://{{{zone}}}.maven.liveperson.net'
  },
  __LPTagDomainsOverrideConfig: {
    z0: "{domain: 'lptag-dev.dev.lprnd.net', tagjs: 'lptag-dev.dev.lprnd.net'}",
    'z0-intg':
      "{domain: 'lptag-z0-intg.liveperson.net', tagjs: 'lptag-z0-intg.liveperson.net'}",
    'z1-a':
      "{domain: 'lptag-a.liveperson.net', tagjs: 'tags-a.liveperson.net'}",
    default: '{}'
  },
  Session: {
    LeServer: 43200,
    KeepAliveInterval: 180,
    AppServerKeepAliveInterval: 1500,
    WarnBeforePeriod: 120,
    BlacklistCodes: [401, 405],
    FaultlistCodes: [404, 500, 502, 503, 504],
    MaxFaultTolerance: 4
  },
  __Session: {
    tlv: { LeServer: 1500 }
  },
  __whatsappBusinessTermsDocument: {
    z1:
      'https://liveperson.na1.echosign.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhDFFuEDr7w_DvDU0ApHFo4nH-Q7ica7jQxMzf8JK7E3-za8N-lJSnkY3Bzfbt3UD88*',
    default:
      'https://liveperson.na1.echosign.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhAecQgYrv30BGOKMRO_6AJvef40lX845xNEWX1hFxXO-hltn6RXPTkCmn1MdOZGJNw* '
  },

  /* Support account on Alpha */
  /*
    "LPtag_mtaconfig": {
        "domain": "lptag-a.liveperson.net",
        "tagjs": "tags-a.liveperson.net",
        "siteId": "75555851"
    },
    */
  /* End Support account on Alpha */

  /* Support account on VA */
  LPtag_mtaconfig: {
    domain: 'lptag.liveperson.net',
    tagjs: 'tags.liveperson.net',
    siteId: '5288836'
  },
  /* End Support account on VA */

  __LPtag_mtaconfig: {
    tlv: {
      domain: 'lptag-dev.dev.lprnd.net',
      tagjs: 'lptag-dev.dev.lprnd.net',
      siteId: 'le66223394'
    },
    dev: {
      domain: 'lptag-dev.dev.lprnd.net',
      tagjs: 'lptag-dev.dev.lprnd.net',
      siteId: 'le66223394'
    }
  },

  __LPtag_config_url: {
    qa:
      'https://lpcdn.lpsnmedia.net/p/lp-cp-tag-support/latest/support_config.json',
    default:
      'https://lpcdn.lpsnmedia.net/p/lp-cp-tag-support/latest/support_config_prod.json'
  },

  __ssoConfigurationKey: {
    tlv: 'A',
    'z1-a': 'LEAlpha',
    default: 'LEGA{{{zone}}}'
  },

  __useFallBackDicitionary: {
    tlv: false,
    default: true
  },

  Billing: {
    trialTimeout: 30,
    oneSeatEnabled: true,
    freemiumDaysBarrier: 300,
    LPComRegisterUrl:
      'https://register.liveperson.com/upgrade?upgradeSiteId={accountId}',
    LPComMyAccountUrl:
      'https://register.liveperson.com/user/login/myaccount?upgradeSiteId={accountId}'
  },
  __Billing: {
    tlv: {
      trialTimeout: 5
    },
    'z1-a': {
      LPComRegisterUrl:
        'https://staging-register.liveperson.com/upgrade?upgradeSiteId={accountId}',
      LPComMyAccountUrl:
        'https://staging-register.liveperson.com/user/login/myaccount'
    }
  },

  __scraperTagletId: {
    tlv: 78597510,
    'z1-a': 10182510,
    default: 24411912
  },

  __environment: {
    tlv: 'qa',
    'z1-a': 'alpha',
    default: 'ga'
  },

  __LPApiAppKey: {
    tlv: '6120eac943a641988c6d8d712bd00579',
    default: '6b7bb399d22047ee9ca34d915714d995'
  },

  connectionPanelChatSettings: {
    fallbackMonitoringDomain: 'base.liveperson.net',
    fallbackSupportAccount: {
      siteId: '801519',
      appKey: '6b7bb399d22047ee9ca34d915714d995'
    },
    fallbackSupportContact: {
      description: 'Need help? Talk to us!',
      displayName: 'Customer Support',
      img:
        'https://s3.amazonaws.com/LPGA/cms::med::ec0b5c65-19cc-4923-d209-09221efccf23',
      skillId: '3',
      id: 3,
      skillName: 'LiveEngage2',
      backupSkillName: null,
      backupSkillId: null,
      engagementType: 'messaging',
      contactType: 'group'
    },
    fallbackSalesContact: {
      description: 'Questions about pricing?',
      displayName: 'Online Sales',
      skillName: 'Registration',
      skillId: '6',
      id: 6,
      img:
        'https://s3.amazonaws.com/LPGA/cms::med::163fd063-6d9d-49cb-b6d8-6958483c737a',
      backupSkillName: null,
      backupSkillId: null,
      engagementType: 'messaging',
      contactType: 'group'
    }
  },

  __connectionPanelChatSettings: {
    tlv: {
      fallbackMonitoringDomain: 'hc1.dev.lprnd.net',
      fallbackSupportAccount: {
        siteId: 'le77576385',
        appKey: 'c60fd5e4b3f44da4920c6fd8acb49558'
      },
      fallbackSupportContact: {
        skillId: '269594312',
        id: 269594312
      },
      fallbackSalesContact: {
        skillId: '343728812',
        id: 343728812
      }
    }
  },

  /* CP Settings for support account on Alpha */
  /*
    "connectionPanelSettings": {
        "chat": {
            "visitorSessionRetryInterval": 1000,
            "visitorSessionMaxAttempts": 5,
            "soundFilesLocation": "/src/modules/connection/assets/sounds/",
            "waitForSurveyTimeout": 60000
        },
       "unifiedWindow": {
           "environment": "prod",
           "windowId": "88928613",
           "authenticationType": "OAUTH_IMPLICIT"
       }

    },
    */
  /* CP Settings for support account on Alpha */

  /* CP Settings for support account on VA */
  connectionPanelSettings: {
    chat: {
      visitorSessionRetryInterval: 1000,
      visitorSessionMaxAttempts: 5,
      soundFilesLocation: '/src/modules/connection/assets/sounds/',
      waitForSurveyTimeout: 60000
    },
    unifiedWindow: {
      environment: 'prod',
      windowId: '1246528514',
      authenticationType: 'OAUTH_IMPLICIT'
    }
  },
  /* CP Settings for support account on VA */

  __connectionPanelSettings: {
    tlv: {
      unifiedWindow: {
        environment: 'qa',
        windowId: '302813612',
        authenticationType: 'OAUTH_IMPLICIT'
      }
    },
    dev: {
      unifiedWindow: {
        environment: 'qa',
        windowId: '302813612',
        authenticationType: 'OAUTH_IMPLICIT'
      }
    }
  },

  __facebookConfiguration: {
    tlv: { showFacebookConnector: true, appId: '2741069036108410' },
    'z1-a': { showFacebookConnector: true, appId: '124455461233435' },
    z1: { showFacebookConnector: true, appId: '1012962928756865' },
    z2: { showFacebookConnector: true, appId: '1712570165669094' },
    z3: { showFacebookConnector: true, appId: '690022217842607' },
    default: { showFacebookConnector: true, appId: '2741069036108410' }
  },

  __instagramConfiguration: {
    tlv: { showFacebookConnector: true, appId: '846735059430234' },
    'z1-a': { showFacebookConnector: true, appId: '745317913060946' },
    z1: { showFacebookConnector: true, appId: '392051075515930' },
    z2: { showFacebookConnector: true, appId: '470330110604696' },
    z3: { showFacebookConnector: true, appId: '668758877152698' },
    default: { showFacebookConnector: true, appId: '846735059430234' }
  },

  __emailConnectorConfigurationDomain: {
    qa: 'https://lp-maamonboarding-qa.dev.lprnd.net',
    lo: false,
    nl: false,
    sy: false,
    ml: false,
    default: 'https://{{{dc}}}.maam-setup.liveperson.net'
  },

  __socialConnectConnectorConfigurationDomain: {
    qa: 'https://socialconnect.dev.conversable.com/entry/{{{zone}}}',
    'z1-a': 'https://socialconnect.staging.conversable.com/entry/{{{zone}}}',
    z1: 'https://oh.socialconnect.liveperson.net/entry/{{{zone}}}',
    z2: 'https://sy2.socialconnect.liveperson.net/entry/{{{zone}}}',
    z3: 'https://du.socialconnect.liveperson.net/entry/{{{zone}}}',
    default: 'https://oh.socialconnect.liveperson.net/entry/{{{zone}}}'
  },

  //static values (hopefully)
  LPService: 'liveEngage',
  defaultRoute: '/wa/webagent',
  connectorsOnboardingSurveyDomain: 'https://www.liveperson.com',
  serviceStatusDomain: 'https://status.liveperson.com',
  developersCommunityDomain: 'https://developers.liveperson.com',
  livepersonIncPath: 'https://livepersoninc.github.io/dev-hub',
  connectionPanelEnabled: true,
  connectionPanelAutoStart: true,
  connectionPanelAvailabilityCheckInterval: 30000,
  NotificationsDefaults: {
    DesktopNotification: {
      focusStatus: 1
    }
  },
  customWidgets: {
    loadTimeout: 30000,
    maxParallelTasks: 2
  },
  LPPublicKey:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC0RYy+YqdUE2rR0gWhT3B8+JjAhGvwSFepUOiFH6QZZXmlCsqu63BztnWSPF3Cjz68K4WAiY5P18AVkGa2JWqVv6v/XaugJHwCRE3TBoG7ddFkecTYEVjWalBRCtvP19deGjBzSHXbt1iy2Y79KP4y43UQXgjQyNCejahpQm/7rwIDAQAB',

  // feature flags
  c4mSkillSelection: true,
  supportDeletedUsers: true,
  c4mMobileApp: true,
  appCreation: true,
  usersBatchUpdates: {
    enabled: true
  },
  actionableConversations: true,
  scheduledWorkingHours: true,
  scheduledCampaigns: true,
  sendPDCEventForMessaging: true,
  transferSkills: true,

  useNewVisitorFeedV2: true,
  visitorfeedv2FixAccounts: [],
  postConvSurveyFilter: true,
  postConvSurveyFilterInvalidFreeText: true,
  postConvSurveyFilterOpenText: true,
  automationTabLandingVideo: 'https://player.vimeo.com/video/302277356',
  appsConfig: {
    dev: {
      basePathTemplate: '{lpCdnDomain}:{version}/',
      filePath: 'app.js'
    },
    app: {
      basePathTemplate: '{lpCdnDomain}le/apps/{appName}/{version}/',
      filePath: 'js/app.js'
    }
  },

  leDependenciesConfig: {
    infra: {
      basePathTemplate: '{lpCdnDomain}le/infra/vue/{version}/',
      filePath: 'js/app.infra.global.min.js'
    }
  },
  defaultLeResourceDomain: 'https://lp-cdn-qa.dev.lprnd.net/',

  topLevelExternalLinks: {
    knowledgeCenter: 'https://knowledge.liveperson.com',
    developersCommunity: 'https://developers.liveperson.com'
  },
  enableExternalKnowledgeCenterKpLinks: true,
  externalKnowledgeCenterLinkTemplate:
    'https://knowledge.liveperson.com/{{kpID}}.html',
  __launchpadClientId: {
    dev: 'ac47580c-b1db-4b72-86bf-c6aed92c867d',
    tlv: 'ac47580c-b1db-4b72-86bf-c6aed92c867d',
    'z1-a': '86fb9018-803f-430f-a2d7-f9e2e55bf3be',
    default: 'd59df109-c246-4715-b5eb-e43eaacd0759'
  },
  externalDevelopersCommunityLinkTemplate:
    'https://developers.liveperson.com/{{kpID}}.html',
  isReportBuilderSupportSSO: false,
  reportBuilderFixAccounts: ['*'],
  wsGetClockInterval: 10000,
  agentSurveyFilter: true,
  showNewAgentWorkspaceInvitation: false,
  showMessagingLoadBalance: true,
  addSourceQueryParameter: true,
  showIVRservice: true,
  isBamSupportEnabled: true
});
